import request from '../utils/request';

// 我的消息列表
export function getLists() {
  return request({
    url: '/frontAudience/message/getMsgList',
    method: 'get',
  });
}
// 获取聊天记录;
export function getMessage(data) {
  return request({
    url: '/frontAudience/message/getMsgRecord',
    method: 'get',
    params: data,
  });
}

// 获取展商信息
export function getzsMessage(data) {
  return request({
    url: '/frontAudience/message/getExhibitorInformation',
    method: 'get',
    params: data,
  });
}

// 发送信息
export function sendMessage(data) {
  return request({
    url: '/frontAudience/message/sendMsg',
    method: 'post',
    data: data,
  });
}
